import { ChartAPIFunctionProps } from '~/types/create.types';
import { getBarColor, mapBars } from '~/utils/time-series';

export const drawCandles = ({
  x,
  y,
  options,
  context,
  timeseries,
  data,
  domain,
}: ChartAPIFunctionProps) => {
  const barSpacing = x.barSpacing;
  const preparedTs = mapBars(timeseries, data, domain);
  const sideWidth = Math.round(0.3 * barSpacing * 1.5);
  const barWidth = sideWidth * 2;
  const wickWidth = 1;
  const wickOffset = wickWidth / 2;

  for (const bar of preparedTs) {
    const color = getBarColor(bar, options);
    context.fillStyle = color;

    const high = y.yScale(bar.high);
    const low = y.yScale(bar.low);
    const open = y.yScale(bar.open);
    const close = y.yScale(bar.close);

    const barHigh = Math.round(Math.min(high, low));
    const barLow = Math.round(Math.max(high, low));
    const top = Math.round(Math.min(open, close));
    const bottom = Math.round(Math.max(open, close));

    const bodyCenter = Math.round(x.xScale(bar.index));
    const left = bodyCenter - wickOffset;
    const right = left + wickWidth - 1;
    const width = right - left + 1;

    //draw wicks
    context.fillRect(left, barHigh, width, top - barHigh);
    context.fillRect(left, bottom + 1, width, barLow - bottom);

    //draw wax
    const borderLeft = bodyCenter - barWidth / 2;
    context.strokeStyle = color;
    context.beginPath();
    //it picks up the type of context from the d3 for some reason during linting
    //@ts-ignore
    context.roundRect(borderLeft, top, barWidth, bottom - top + 1, 1);
    context.fill();
    context.stroke();
  }
};
